var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QInput',{attrs:{"label":"Description","rounded":"","standout":"","stack-label":"","type":"textarea","value":_vm.value},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }